import { onHover } from '@/services/utils/checkShowTooltip'


export class GlobalUtils {
  install(Vue: any, options: any) {
    Vue.prototype.$utils = {
      onTooltipHover: onHover,
    };
  }
}

export default new GlobalUtils();
